import type { Progress } from '@/types';
import styles from './ProgressBars.module.css';

interface Props {
  progress?: Progress;
  /** Color principal (hitos). Default: var(--brand). */
  color?: string;
  /** Compacto: barras más finas, sin labels. Default: false. */
  compact?: boolean;
}

/**
 * R4 — Dos barras de progreso uniformes para cualquier card de la jerarquía
 * (cliente / facility / propuesta / EV / iniciativa).
 *  - Barra 1: Hitos entregados / (total - suspendidos)
 *  - Barra 2: Compromisos completados / (total - suspendidos)
 */
export function ProgressBars({ progress, color, compact }: Props) {
  if (!progress) return null;
  const c = color || 'var(--brand)';
  const h = progress.hitos;
  const co = progress.compromisos;

  return (
    <div className={compact ? styles.wrapCompact : styles.wrap}>
      <div className={styles.row}>
        {!compact && (
          <div className={styles.label}>
            <span>Hitos</span>
            <span className={styles.numbers}>
              {h.done}/{h.total} · {h.pct}%
            </span>
          </div>
        )}
        <div className={styles.bar}>
          <div className={styles.fill} style={{ width: `${h.pct}%`, background: c }} />
        </div>
      </div>
      <div className={styles.row}>
        {!compact && (
          <div className={styles.label}>
            <span>Compromisos</span>
            <span className={styles.numbers}>
              {co.done}/{co.total} · {co.pct}%
            </span>
          </div>
        )}
        <div className={styles.bar}>
          <div
            className={styles.fill}
            style={{ width: `${co.pct}%`, background: c, opacity: 0.55 }}
          />
        </div>
      </div>
    </div>
  );
}
